<template>
	<div class="bkf7 gameall_list" v-if="login && isAdmin">
		<el-container>
			<div class="inter2">
				<div class="filter-keywords-search" v-if="!isMobile">
					<div class="filter-search-label">关键词</div>
					<div class="filter-search-info">
						<div class="filter-search-input el-input el-input--suffix">
							<input type="text" autocomplete="off" v-model="keyword" placeholder="请输入关键字"
								class="el-input__inner"><span class="el-input__suffix">
								<span class="el-input__suffix-inner" @click="Search">
									<div class="search">搜索</div>
								</span></span>
						</div>
					</div>
				</div>
				<div class="mobile-filter-search" v-if="isMobile">
					<div class="mobile-search-box">
						<input type="text" v-model="keyword" placeholder="请输入关键字" class="mobile-search-input" />
						<button class="mobile-search-btn" @click="Search">搜索</button>
					</div>
				</div>
				<el-row>
					<div class="sortpaixu">
						<ul class="sortpaixu_ul">
							<li :class="{ 'active': sortactive == 1 }" @click="chose_sort(1)"><span>推荐排序</span></li>
							<li :class="{ 'active': sortactive == 2 }" @click="chose_sort(2, sort)">
								<span>结算比例</span><span v-if="sortactive == 2 && sort == 0">↑</span><span
									v-if="sortactive == 2 && sort == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 3 }" @click="chose_sort(3, sort)">
								<span>总资产</span><span v-if="sortactive == 3 && sort == 0">↑</span><span
									v-if="sortactive == 3 && sort == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 4 }" @click="chose_sort(4, sort)">
								<span>哈夫币</span><span v-if="sortactive == 4 && sort == 0">↑</span><span
									v-if="sortactive == 4 && sort == 1">↓</span>
							</li>
						</ul>
					</div>
				</el-row>
				<el-row v-if="isMobile">
					<div class="mobile_home_game" :key="mo_index">
						<div class="item" v-for="(item, index) in list">
							<div class="w_con1">
								<div class="wtext_1">
									<div class="image">
										<img src="@/assets/image/tu_biao.png" />
									</div>
									<div class="text">
										<p class="p1">{{ item.account_no || item.id }}</p>
										<p class="p2"> 编号：{{ item.account_no || item.id }} </p>
										<div class="p3">
											<div class="price1">
												<span class="sp1">￥</span>
												<span class="sp2">{{ item.price }}</span>
												<span class="sp3">租金</span>
											</div>
											<div class="price2">
												<span class="sp1">￥</span>
												<span class="sp2">{{ item.yajin }}</span>
												<span class="sp3">押金</span>
											</div>
										</div>
									</div>
								</div>
								<div class="wtext_2">
									<div class="text">
										<p class="p1">{{ item.daopi || '-' }}</p>
										<p class="p2">刀皮</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.chunbi }}</p>
										<p class="p2">纯币资产(m)</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.box }}</p>
										<p class="p2">安全箱</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.awm }}</p>
										<p class="p2">AWM子弹</p>
									</div>
								</div>
								<div class="wtext_3">
									<div class="fr">
										<el-button size="mini" style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;" @click.stop="restoreAccount(item.id)">恢复</el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-row>
				<el-row v-else>
					<el-col :span="24">
						<el-table :data="list" border style="width: 100%" @row-click="goToDetail" class="my-table">
							<el-table-column fixed="left" prop="account_no" label="编号" width="100">
							</el-table-column>
							<el-table-column prop="qufu" label="区服" width="80">
								<template slot-scope="scope">
									<span :class="scope.row.qufu === '2' ? 'color-wechat color-div' : 'color-qq color-div'">
										{{ scope.row.qufu == '2' ? '微信' : scope.row.qufu == '1' ? 'QQ' : '-' }}
									</span>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100px" prop="login_type" label="登录方式">
								<template slot-scope="scope">
									<span :class="scope.row.login_type === '1' ? 'color-sm color-div' : 'color-qq color-div'">
										{{ scope.row.login_type == '1' ? '扫码登录' : scope.row.login_type == '2' ? '账号密码' : '-' }}
									</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="is_ben" label="本人人脸" width="80">
								<template slot-scope="scope">
									<span>{{ scope.row.is_ben == '1' ? '是' : scope.row.is_ben == '0' ? '否' : '-' }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="changzhu" label="常用登陆地" min-width="100">
								<template slot-scope="scope">
									<span>{{ getFilterName('changzhu', scope.row.changzhu) || scope.row.changzhu }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="duanwei" label="段位" width="80">
								<template slot-scope="scope">
									<span>{{ getFilterName('duanwei', scope.row.duanwei) }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" width="110px" prop="chunbi" label="纯币资产(m)">
								<template slot="header">
									<span>纯币资产(m)</span>
									<el-tooltip content="纯币资产单位 1M=100万" placement="top">
										<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="bili" label="比例" width="70">
								<template slot="header">
									<span>比例</span>
									<el-tooltip content="以1：40为例，表示1元=40万哈夫币" placement="top">
										<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="level" label="等级" width="70">
							</el-table-column>
							<el-table-column align="center" prop="xunlian" label="训练等级" min-width="90">
								<template slot-scope="scope">
									<span>{{ scope.row.xunlian }}级</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="bachang" label="靶场等级" min-width="90">
								<template slot-scope="scope">
									<span>{{ scope.row.bachang }}级</span>
								</template>
							</el-table-column>
							<el-table-column align="center" min-width="120px" prop="box" label="安全箱">
								<template slot-scope="scope">
									<span class="color-sm color-div" :class="['color-div_box' + scope.row.box]">
										{{ getFilterName('box', scope.row.box) }}
									</span>
								</template>
							</el-table-column>
							<el-table-column align="center" min-width="90px" prop="awm" label="AWM子弹">
							</el-table-column>
							<el-table-column align="center" prop="daopi" label="刀皮" min-width="100">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" :content="getFilterNameList('daopi', scope.row.daopi)" placement="left">
										<span class="sp_text">{{ getFilterNameList('daopi', scope.row.daopi) }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="ganyuan" label="干员皮" min-width="100">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" :content="getFilterNameList('ganyuan', scope.row.ganyuan)" placement="left">
										<span class="sp_text">{{ getFilterNameList('ganyuan', scope.row.ganyuan) }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="wuqi" label="武器皮" min-width="100">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" :content="getFilterNameList('wuqi', scope.row.wuqi)" placement="left">
										<span class="sp_text">{{ getFilterNameList('wuqi', scope.row.wuqi) }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="price" label="价格(元)" min-width="80">
							</el-table-column>
							<el-table-column align="center" prop="yajin" label="押金(元)" min-width="80">
							</el-table-column>
							<el-table-column align="center" prop="kd" label="KD" min-width="60">
								<template slot-scope="scope">
									<span>{{ scope.row.kd || '-' }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="beizhu" label="备注" min-width="120">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" :content="scope.row.beizhu" placement="left">
										<span class="sp_text">{{ scope.row.beizhu }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" fixed="right" label="操作" width="100">
								<template slot-scope="scope">
									<el-button size="mini" style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;" @click.stop="restoreAccount(scope.row.id)">恢复</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="page"
					:page-sizes="[10, 20, 30, 40]"
					:page-size="limit"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</el-container>
	</div>
	<div v-else>
		<el-alert title="请登录管理员账号访问" type="warning" show-icon />
	</div>
</template>
<script>
export default {
	data() {
			return {
				keyword: '',
				page: 1,
				limit: 20,
				total: 0,
				list: [],
				loading: false,
				sortactive: 1,
				sort: 0,
				mo_index: 0
			}
		},
	computed: {
		login() {
			return this.$store.getters.login
		},
		userinfo() {
			return this.$store.getters.userinfo
		},
		isMobile() {
			return this.$store.getters.isMobile
		},
		gamelist() {
			return this.$store.getters.gamelist
		},
		config() {
			return this.$store.getters.config
		},
		allGameList() {
			return this.$store.getters.allGameList
		},
		isAdmin() {
			return this.$store.getters.isAdmin
		}
	},
	mounted() {
		this.getList()
	},
	methods: {
		getFilterName(type, value) {
			if (!value && value !== 0) return '-'
			const map = {
				box: { '1': '2格', '2': '4格', '3': '6格', '4': '9格' },
				duanwei: { '0': '无段位', '1': '青铜', '2': '白银', '3': '黄金', '4': '铂金', '5': '钻石', '6': '黑鹰', '7': '三角洲巅峰' }
			}
			return map[type] && map[type][value] ? map[type][value] : value
		},
		getFilterNameList(type, value) {
			if (!value) return '-'
			const map = {
				daopi: { '1': '信条', '2': '赤霄', '3': '怜悯', '4': '影锋', '5': '黑海', '6': '北极星', '7': '电锯惊魂', '8': '龙牙', '9': '暗星' },
				ganyuan: { '1': '红狼 - 蚀金玫瑰', '2': '红狼 - 黑鹰坠落', '3': '威龙 - 蛟龙行动', '4': '威龙 - 铁面判官', '5': '威龙 - 吴彦祖', '6': '蜂医 - 送葬人', '7': '蜂医 - 黑鹰坠落', '8': '蜂医 - 危险物质', '9': '无名 - 夜鹰', '10': '乌鲁售・黑鹰坠落', '11': '牧羊人 - 黑鹰坠落', '12': '牧羊人 - 街头之王', '13': '露娜 - 黑 - 天际线', '14': '蛊 - 能天使 - 午夜邮差', '15': '骇爪 - 维什戴尔', '16': '骇爪 - 水墨云图', '17': '露娜 - 金牌射手', '18': '深蓝 - 不破之誓', '19': '红狼 - 电锯惊魂', '20': '威龙 - 凌霄戍卫' },
				wuqi: { '1': 'M7 棱镜攻势', '2': 'M4 棱镜攻势', '3': 'K416 - 命运', '4': 'SCAR - 电玩', '5': '腾龙 - 气象感应', '6': 'QBZ95 - 王牌之剑', '7': 'Vctor - 中锋枪 - 美杜莎', '8': 'AS Val 突击步枪 - 悬赏令', '9': 'AUG - 气象感应' }
			}
			if (!map[type]) return value
			const list = value.split(',').map(v => map[type][v] || v)
			return list.join(', ')
		},
		goToDetail(row) {
			window.location.href = '/goodsdetail?id=' + row.id
		},

		getList() {
			this.loading = true
			this.rq.requests.post('api/game/hall/getDeletedAccounts', {
				page: this.page,
				limit: this.limit,
				keyword: this.keyword,
				sortactive: this.sortactive,
				sort: this.sort
			}).then(res => {
				this.list = res.data.data
				this.total = res.data.total
				this.loading = false
			})
		},
		Search() {
			this.page = 1
			this.getList()
		},
		chose_sort(sortactive, sort) {
			this.sortactive = sortactive
			this.sort = sort === 0 ? 1 : 0
			this.page = 1
			this.getList()
		},
		handleSizeChange(val) {
			this.limit = val
			this.page = 1
			this.getList()
		},
		handleCurrentChange(val) {
			this.page = val
			this.getList()
		},
		restoreAccount(id) {
			this.rq.requests.post('api/game/hall/restoreAccount', { id: id }).then(res => {
				this.$message.success('恢复成功')
				this.getList()
			})
		}
	}
}
</script>
<style scoped>
.filter-keywords-search {
	display: flex;
	align-items: center;
	padding: 15px 20px;
	background: #fff;
	border-radius: 8px;
	margin-bottom: 15px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.filter-search-label {
	width: 70px;
	font-size: 14px;
	font-weight: 500;
	color: #acb6c2;
}
.filter-search-info {
	flex: 1;
	display: flex;
	align-items: center;
}
.filter-search-input {
	flex: 1;
	max-width: 400px;
}
.filter-search-input input {
	height: 36px;
	line-height: 36px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	padding: 0 50px 0 15px;
	font-size: 14px;
	transition: border-color 0.3s;
}
.filter-search-input input:focus {
	border-color: #1f9535;
	outline: none;
}
.search {
	width: 50px;
	height: 100%;
	line-height: 36px;
	text-align: center;
	color: #1f9535;
	border-radius: 0 4px 4px 0;
	cursor: pointer;
	font-size: 14px;
	transition: background 0.3s;
}
.search:hover {
	background: #17822b;
}
.mobile-filter-search {
	padding: 10px;
	background: #fff;
	margin-bottom: 10px;
}
.mobile-search-box {
	display: flex;
	gap: 10px;
}
.mobile-search-input {
	flex: 1;
	height: 36px;
	padding: 0 12px;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 14px;
}
.mobile-search-btn {
	padding: 0 20px;
	height: 36px;
	background: #1f9535;
	color: #fff;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
}
</style>